import AppConstants from '../config/app.constants';

let BranchService = function ($http, $q) {//don't need this $q 

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/branch`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/branch/create`, data)
            .then((res) => {
                return res.data
            })
    }

    let remove = (id) => {
        return $http
            .delete(AppConstants.api + `/branch/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/branch/${id}`, data)
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/branch/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let getReleaseRoutes = (id, date, coinCheckOut) => {
        return $http
            .get(AppConstants.api + `/branch/${id}/route-list?date=${date}&coinCheckOut=${coinCheckOut}`)
            .then((res) => {
                return res.data;
            })
    }

    let getBranchSetup = (id) => {
        return $http
            .get(AppConstants.api + `/branch/${id}/setup`)
            .then((res) => {
                return res.data;
            })
    }

    
    let verifyCloseVault = (id, userId, userTimeZone) => {
        return $http
            .post(AppConstants.api + `/branch/${id}/verify-close-vault`, { userId, userTimeZone })
            .then((res) => {
                return res.data
            });
    }

    let closeVault = (id, userId, vaultDate) => {
        return $http
            .post(AppConstants.api + `/branch/${id}/close-vault`, { userId, vaultDate })
            .then((res) => {
                return res.data
            });
    }

    let verifyVault = (id, date) => {
        return $http
            .get(AppConstants.api + `/branch/${id}/verify-vault?date=${date}`)
            .then((res) => {
                return res.data
            });
    }

    let truncateRoute = (id) => {
        return $http
            .post(AppConstants.api + `/branch/${id}/truncate-route`)
            .then((res) => {
                return res.data
            })
    }

    let getTankersAvailable = (id) => {
        return $http
            .get(AppConstants.api + `/branch/${id}/tankers-available`)
            .then((res) => {
                return res.data
            })
    }

    let validateRouteCheckIn = (routeId, vaultDate, branchId, userId) => {
        return $http
            .post(AppConstants.api + `/branch/${branchId}/validate-route-checkIn`, {
                routeId,
                vaultDate,
                branchId,
                userId
            })
            .then((res) => {
                return res.data
            })
    }

    let cancelShipmentTransfer = (shipmentDetails, cancelTransferState, branchId) => {
        return $http
            .post(AppConstants.api + `/branch/${branchId}/cancel-shipment-transfer`, { shipmentDetails, cancelTransferState })
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        create,
        remove,
        update,
        get,
        getReleaseRoutes,
        getBranchSetup,
        verifyCloseVault,
        closeVault,
        truncateRoute,
        verifyVault,
        getTankersAvailable,
        validateRouteCheckIn,
        cancelShipmentTransfer
    };
};

BranchService.$inject = ['$http', '$q']

export default BranchService;


// WEBPACK FOOTER //
// ./client/app/services/branch.service.js